// Generated by purs version 0.15.7
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Freer from "../Freer/index.js";
import * as Machine from "../Machine/index.js";
import * as Parser from "../Parser/index.js";
import * as Syntax from "../Syntax/index.js";
import * as Web_DOM_Element from "../Web.DOM.Element/index.js";
import * as Web_DOM_Node from "../Web.DOM.Node/index.js";
import * as Web_DOM_ParentNode from "../Web.DOM.ParentNode/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_HTMLDocument from "../Web.HTML.HTMLDocument/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var logShow = /* #__PURE__ */ Effect_Class_Console.logShow(Effect_Class.monadEffectEffect);
var logShow1 = /* #__PURE__ */ logShow(/* #__PURE__ */ Data_Show.showArray(Machine.instructinoShow));
var map = /* #__PURE__ */ Data_Functor.map(Freer.effFunctor);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Freer.effApplicative);
var map1 = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var unsafeRun = /* #__PURE__ */ Freer.unsafeRun(Machine.instructinoShow);
var logShow2 = /* #__PURE__ */ logShow(Data_Show.showString);
var unsafeInterpret = function (s) {
    var res = Parser.runParser(Syntax.program)(s);
    if (res instanceof Parser.Ok) {
        return function __do() {
            logShow1(res.value0)();
            var runnable = map(Data_Function["const"](Data_Unit.unit))(traverse(Freer.eff)(res.value0));
            return map1(Data_Function["const"](Data_Unit.unit))(pure(unsafeRun(Machine.execute)(runnable)))();
        };
    };
    if (res instanceof Parser.Err) {
        return logShow2(res.value0 + ("," + res.value1));
    };
    throw new Error("Failed pattern match at Main (line 24, column 5 - line 30, column 45): " + [ res.constructor.name ]);
};
var main = function __do() {
    var win = Web_HTML.window();
    var doc = Web_HTML_Window.document(win)();
    var el = Web_DOM_ParentNode.querySelector("#script")(Web_HTML_HTMLDocument.toParentNode(doc))();
    var script = (function () {
        if (el instanceof Data_Maybe.Just) {
            return Web_DOM_Node.textContent(Web_DOM_Element.toNode(el.value0))();
        };
        if (el instanceof Data_Maybe.Nothing) {
            return "";
        };
        throw new Error("Failed pattern match at Main (line 37, column 13 - line 39, column 23): " + [ el.constructor.name ]);
    })();
    return unsafeInterpret(script)();
};
export {
    unsafeInterpret,
    main
};
